import BillingContainer from './containers/BillingContainer';

export default BillingContainer;
